import React, {useEffect} from 'react';

const Page = (): JSX.Element => {
  useEffect(() => {
    document.body.style.overflow = 'hidden';
  }, []);

  return (
    <iframe
      title="Running power definition"
      src="https://drive.google.com/viewerng/viewer?embedded=true&url=https://storage.googleapis.com/stryd_static_assets/white_papers/power-definition-2.pdf"
      style={{
        position: 'relative',
        width: '100%',
        height: '100vh',
        border: 'none',
        scrollBehavior: 'auto',
      }}
    ></iframe>
  );
};

export default Page;
